import { HStack } from '@cbhq/cds-web/layout';

import { ProductFilterCategory } from ':cloud/content/products';
import FilterButton from ':cloud/widgets/product/FilterButton';

const productFilterCategories = [
  ProductFilterCategory.ALL,
  ProductFilterCategory.STAKING,
  ProductFilterCategory.PAYMENTS,
  ProductFilterCategory.WALLETS,
  ProductFilterCategory.OFF_PLATFORM,
];

type FilterButtonGroupProps = {
  selectedFilters: Set<ProductFilterCategory>;
  handleFilterChange: (filter: ProductFilterCategory) => void;
};

function FilterButtonGroup({ selectedFilters, handleFilterChange }: FilterButtonGroupProps) {
  return (
    <HStack flexWrap="nowrap" overflow="auto" spacingBottom={5} gap={1} justifyContent="flex-start">
      {productFilterCategories.map((product: ProductFilterCategory) => (
        <FilterButton
          key={product}
          label={product}
          onPress={() => handleFilterChange(product)}
          isSelected={selectedFilters.has(product)}
        />
      ))}
    </HStack>
  );
}
export default FilterButtonGroup;
